import axios from './axios';

const axiosInstance = { ...axios };
export default axiosInstance;
